import type { Gradient } from '@jouzen/ecom-components/v3/RadialGradient';

const sleepAndRestHeroBgGradients: Gradient[] = [
  {
    shape: 'circle',
    hex: '#384954',
    id: 'gradient-1',
    position: [10, 90],
    opacity: 1,
    size: 25,
  },
  {
    shape: 'circle',
    hex: '#384954',
    id: 'gradient-2',
    position: [90, 30],
    opacity: 1,
    size: 25,
  },
  {
    shape: 'circle',
    hex: '#D7E2E8',
    id: 'gradient-3',
    position: [10, 10],
    opacity: 0.3,
    size: 25,
  },
  {
    shape: 'circle',
    hex: '#D7E2E8',
    id: 'gradient-4',
    position: [90, 90],
    opacity: 0.3,
    size: 20,
  },
  {
    shape: 'circle',
    hex: '#D7E2E8',
    id: 'gradient-5',
    position: [70, 90],
    opacity: 0.2,
    size: 20,
  },
  {
    shape: 'circle',
    hex: '#D7E2E8',
    id: 'gradient-6',
    position: [60, 60],
    opacity: 0.1,
    size: 20,
  },
];

export default sleepAndRestHeroBgGradients;
